import { Component, OnInit, ViewChild, Input, EventEmitter, Output } from '@angular/core';
import {
  QuestionBase,
  TagsQuestion,
  DynamicFormComponent,
  DropdownQuestion,
  QuestionGroup
} from 'core/components/forms';
import { ModalComponent } from '../../modal/modal.component';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

const EDIT_ACTIONS = [
  { key: 'add', value: 'tasks.tags.addTitle' },
  { key: 'delete', value: 'tasks.tags.deleteTitle' }
];
@Component({
  selector: 'lms-edit-tags',
  templateUrl: './edit-tags.component.html',
  styleUrls: ['./edit-tags.component.scss']
})
export class EditTagsComponent implements OnInit {
  @Input() list: any = [];
  @Input() count: number;
  @Output() tagsSelected = new EventEmitter<any>();
  @Output() addTagsSelected = new EventEmitter<any>();
  @Output() removeTagsSelected = new EventEmitter<any>();
  @ViewChild('modalTagsSelector', { static: false }) public modalTagsSelector: ModalComponent;
  @ViewChild(DynamicFormComponent, { static: false }) public dynamicForm: DynamicFormComponent;
  public profileSubscription: Subscription;
  public weeks = 0;
  public groupEndDateString;
  public licenseEndDateString;
  public items: any[];
  questions: QuestionBase<any>[] = [];
  formError: any;
  userRole: any;

  constructor(public translateService: TranslateService) {}

  ngOnInit() {
    this.items = EDIT_ACTIONS.map((action) => ({
      key: action.key,
      value: this.translateService.instant(action.value)
    }));
  }

  openModal() {
    this.modalTagsSelector.open();
    this.setTagQuestion();
  }

  setTagQuestion() {
    this.questions = [
      new QuestionGroup({
        childQuestions: [
          new DropdownQuestion({
            key: 'action',
            class: 'col-1',
            label: 'actions.action',
            placeholder: 'actions.select',
            options: this.items,
            validators: { required: true }
          }),
          new TagsQuestion({
            key: 'tags',
            label: 'nouns.tags',
            class: 'col-1',
            value: [],
            validators: { required: true },
            order: 11
          })
        ]
      })
    ];
  }

  canSendForm(tagsForm) {
    if (tagsForm && tagsForm.form) {
      return !tagsForm.form.invalid;
    }
    return false;
  }

  confirmTags() {
    const { action, tags } = this.dynamicForm.form.value;
    if (action === 'add') {
      this.addTags(tags);
    } else {
      this.deleteTags(tags);
    }
  }

  addTags(tags) {
    this.modalTagsSelector.close();
    this.addTagsSelected.emit(tags);
  }

  deleteTags(tags) {
    this.modalTagsSelector.close();
    this.removeTagsSelected.emit(tags);
  }
}
